module.exports = __webpack_public_path__ + "static/dl2-stay-human_redstripe-0e10cb2115c1f3b85a2270b51cfbb1c3.png";